<template>
  <div>
    <div class="box">
      <p class="return" @click="back">返回首页</p>
      <span class="line">|</span>
      <p class="contract">系统设置</p>
      <span class="lines">></span>
      <p class="contract back" @click="$router.go(-2)">合同公司</p>
      <span class="lines">></span>
      <p class="contract back" @click="$router.go(-1)">公司印章</p>
      <span class="lines">></span>
      <p class="contract">添加公司印章</p>
    </div>
    <div class="mainTitle">添加公司印章</div>

    <div class="content" v-loading="loading" element-loading-text="Loading...">
      <!-- <el-switch :width="120" v-model="switchValue" active-color="#6669e3" inactive-color="#b8b8c4" :active-text="switchValue ? '以信息添加':'以图像添加'"></el-switch> -->
      <div class="form" v-show="switchValue">
        <div class="left">
          <el-form
            :model="sealForm"
            :rules="rules"
            ref="sealForm"
            label-width="100px"
            label-position="right"
            style="width: 100%"
          >
            <el-form-item label="印章名称" prop="name">
              <el-input
                maxlength="20"
                v-model="sealForm.name"
                placeholder="请输入印章名称"
              ></el-input>
            </el-form-item>
            <el-form-item label="印章类型" prop="templateType">
              <el-select
                placeholder="请选择印章类型"
                v-model="sealForm.templateType"
              >
                <el-option
                  v-for="item in sealTypes"
                  :key="item.id"
                  :label="item.value"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <!-- <el-form-item label="印章上弦文" prop="roundText">
              <el-input
                maxlength="20"
                v-model="sealForm.roundText"
                placeholder="请输入印章上弦文"
              ></el-input>
            </el-form-item> -->
            <el-form-item label="印章横向文" prop="htext">
              <el-input
                maxlength="20"
                v-model="sealForm.htext"
                placeholder="请输入印章横向文"
              ></el-input>
            </el-form-item>
            <el-form-item label="印章下弦文" prop="qtext">
              <el-input
                maxlength="20"
                v-model="sealForm.qtext"
                placeholder="请输入印章下弦文"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="right"></div>
      </div>
      <div slot="footer" class="btndiv">
        <button class="btn" @click="cancelDialogForm">重 置</button>
        <button class="subbtn btn" @click="addSeal">确 定</button>
      </div>

      <div class="form" v-show="!switchValue">
        <el-form
          :model="sealImgForm"
          :rules="imgRules"
          ref="sealImgForm"
          label-width="100px"
          label-position="left"
        >
          <el-form-item label="印章名称" prop="name" style="width: 625px">
            <el-input
              v-model="sealImgForm.name"
              style="width: 525px"
            ></el-input>
          </el-form-item>
          <el-form-item label="印章图像" style="width: 625px">
            <!-- <upload></upload> -->
          </el-form-item>
        </el-form>
        <div slot="footer" class="btndiv">
          <button class="btn" @click="cancelDialogImgForm">重 置</button>
          <button class="subbtn btn">确 定</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      company_id: this.$route.query.cid,
	  orgId:this.$route.query.id,
      title: "添加",
      switchValue: true,
      sealForm: {
        name: "",
        templateType: "",
        // roundText: "",
        htext: "",
        qtext: "",
        contractCompanyId: this.$route.query.cid, //合同公司id
        // customerId: "",
      },
      rules: {
        name: [
          {
            required: true,
            message: "请输入印章名称",
            trigger: "blur",
          },
          {
            min: 3,

            message: "长度最少3个字符",
          },
        ],
        templateType: [
          {
            required: true,
            message: "请选择印章类型",
            trigger: "change",
          },
        ],
        roundText: [
          {
            required: true,
            message: "请输入上弦文内容",
            trigger: "blur",
          },
          {
            min: 4,
            message: "长度最少4个字符",
          },
        ],
        htext: [
          {
            message: "请输入横向文内容",
            trigger: "blur",
          },
          {
            min: 2,
            message: "长度最少2个字符",
          },
        ],
        qtext: [
          {
            message: "请输入下弦文内容",
            trigger: "blur",
          },
          {
            min: 3,

            message: "长度最少3个字符",
          },
        ],
      },

      sealTypes: [
        {
          id: "PUBLIC_ROUND_STAR",
          value: "圆形公章（带五角星）",
        },
        {
          id: "PUBLIC_OVAL",
          value: "椭圆形公章（不带五角星）",
        },
        {
          id: "PUBLIC_TWO_OVAL",
          value: "双椭圆形公章（不带五角星）",
        },
        {
          id: "CONTRACT_ROUND_NO_STAR",
          value: "合同专用章（圆形章，不带五角星）",
        },
        {
          id: "CONTRACT_ROUND_STAR",
          value: "合同专用章（圆形章，带五角星）",
        },
        {
          id: "PERSONNEL_ROUND_NO_STAR",
          value: "人事专用章（圆形章，不带五角星）",
        },
        {
          id: "PERSONNEL_ROUND_STAR",
          value: "人事专用章（圆形章，带五角星）",
        },
        {
          id: "FINANCE_ROUND_NO_STAR",
          value: "财务专用章（圆形章，不带五角星）",
        },
        {
          id: "FINANCE_ROUND_STAR",
          value: "财务专用章（圆形章，带五角星）",
        },
        {
          id: "FINANCE_SQUARE_HORIZONTAL",
          value: "财务专用章（横排正方形章，不带五角星）",
        },
        {
          id: "FINANCE_SQUARE_VERTICAL",
          value: "财务专用章（竖排正方形章，不带五角星）",
        },
        {
          id: "COMMON_ROUND_STAR",
          value: "其他章（圆形章，带五角星）",
        },
        {
          id: "COMMON_OVAL",
          value: "其他章（椭圆章）",
        },
        {
          id: "COMMON_TWO_OVAL",
          value: "其他章（双椭圆章）",
        },
      ],
      sealImgForm: {
        name: "",
        file: "",
      },
      imgRules: {
        name: [
          {
            required: true,
            message: "请输入印章名称",
            trigger: "blur",
          },
        ],
      },
    };
  },
  created() {},
  mounted() {},
  methods: {
    back() {
      this.$router.push({ path: "/main" });
    },
    cancelDialogForm() {
      this.$refs["sealForm"].resetFields();
    },
    addSeal() {
      this.$refs["sealForm"].validate((valid) => {
        if (valid) {
          this.$axios
            .post("/companyContract/seal/add", this.sealForm)
            .then((res) => {
              if (res.data.status === 1) {
                this.$message.success(res.data.message);
                this.$router.push({
                  path: "../seal",
                  query: {
                    id: this.orgId,
					company_id:this.company_id
                  },
                });
              } else {
                this.$message.error(res.data.message);
              }
            })
            .catch((err) => {
              console.error(err);
            });
        }
      });
    },
    cancelDialogImgForm() {
      this.$refs["sealImgForm"].resetFields();
    },
  },
};
</script>

<style src="../../../../assets/css/common/nav.less" scoped lang="less"></style>
<style scoped lang="less">
.box {
  display: flex;
  margin-top: 20px;

  .return {
    font-size: 12px;
    font-weight: 400;
    color: rgba(102, 105, 227, 1);
    margin-right: 20px;
    cursor: pointer;
  }

  .line {
    margin-right: 20px;
    color: #606266;
  }

  .lines {
    margin-right: 20px;
    color: #606266;
    font-weight: bold;
  }

  .back:hover {
    color: #6669e3;
    cursor: pointer;
  }

  .contract {
    margin-right: 20px;
    font-size: 12px;
    font-weight: 400;
    color: rgba(138, 138, 154, 1);
  }
}

.content {
  width: 100%;
}

.form {
  margin-top: 60px;
  display: flex;
  justify-content: center;
  // 		flex-direction:column;
  // 		align-items: center;
}

.el-form-item {
  margin-bottom: 14px;
}

.tinymce {
  width: 100%;

  p {
    color: #545566;
    font-size: 14px;
    padding: 20px 0;
  }

  .tabs {
    display: flex;
    flex-wrap: wrap;

    .tab {
      width: 120px;
      height: 34px;
      border: 1px solid #6669e3;
      margin-right: 16px;
      margin-bottom: 16px;
      border-radius: 6px;
      line-height: 34px;
      text-align: center;
      font-size: 14px;
      color: #6669e3;
      cursor: pointer;
    }
  }

  .addp {
    padding-bottom: 15px;
  }

  .add {
    margin-bottom: 35px;

    .btn {
      display: flex;
      align-items: center;
      font-size: 14px;

      i {
        color: #fff;
        font-size: 14px;
        font-weight: bolder;
        margin-right: 5px;
      }
    }
  }
}

.btndiv {
  display: flex;
  justify-content: center;
  width: 100%;
  height: 34px;
  margin: 60px 0;

  button {
    margin: 0 8px;
  }
}

.left {
  width: 500px;
  display: flex;
  align-items: center;
  margin-right: 46px;
}

.right {
  width: 460px;
  height: 300px;
  /*background-color: #f2f5f8;*/
  border-radius: 4px;
}

.form /deep/ .el-select {
  width: 100%;
}
.mainTitle {
  font-size: 24px;
  font-weight: bold;
  color: rgba(48, 49, 64, 1);
  margin: 23px 0 33px 0;
}
.form[data-v-49ae3d7a] {
  margin-top: 30px;
  display: flex;
  justify-content: center;
}
</style>
